import { EmptyState } from "@/components/feedback/empty-state";
import { formatRelativeTime } from "@/lib/format/relative-time";

export interface RecentSignup {
  id: string;
  name: string;
  email: string;
  createdAt: Date | string;
  authProvider: string;
}

export interface RecentSignupsCardProps {
  data: RecentSignup[];
  now: Date;
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? "")
    .join("") || "??";
}

export function RecentSignupsCard({ data, now }: RecentSignupsCardProps) {
  if (data.length === 0) {
    return <EmptyState title="No recent signups" />;
  }

  return (
    <div className="flex flex-col">
      {data.map(user => (
        <div
          key={user.id}
          className="grid grid-cols-[32px_1fr_auto] items-center gap-3 border-b border-fc-border py-2.5 last:border-b-0"
        >
          <div className="grid h-8 w-8 place-items-center rounded-lg bg-fc-overlay text-[11.5px] font-semibold text-fc-text">
            {initials(user.name)}
          </div>
          <div className="min-w-0">
            <div className="truncate text-[12.5px] font-medium text-fc-text">
              {user.name}
            </div>
            <div className="truncate text-[11px] text-fc-text-dim">
              {user.email}
            </div>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className="text-[10.5px] uppercase tracking-wide text-fc-text-dim">
              {user.authProvider}
            </span>
            <span className="font-mono text-[11px] text-fc-text-dim">
              {formatRelativeTime(user.createdAt, now)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
